import zmFormula from "./zmFormulaHelperService";
import util from "zmfront-framework/src/utils/util";
import zmFlipRule from "./zmFlipRuleService";
import httpservice from "zmfront-framework/src/utils/httpservice";

const zmCarryRule = {};
//
zmCarryRule.facade = {};
//计抛规则
zmCarryRule.param = {};
zmCarryRule.weig = 0;

zmCarryRule.getResult = function (param) {
    zmFormula.zmformulahelper(param.formula);
    zmFormula.setParam("@wbs", param.weightStart);
    zmFormula.setParam("@w", param.weig);
    //返回执行值
    return parseFloat(zmFormula.evalOfBigDecimal());
};
zmCarryRule.call = function (param) {
    zmCarryRule.param = param;
    let carryRuleList = util.get("carryRuleList");
    if (!carryRuleList || carryRuleList.length <= 0) {
        this.$httpService.get('/bas/carry/rule/list').then(res => {
            if (res) {
                this.$util.set("carryRuleList", res);
                carryRuleList = res;
            }
        }).catch(res => {
        });
    }
    if (carryRuleList == null || carryRuleList.length < 1) {
        return zmFlipRule.param.weig;
    }
    let carryRule = {};
    for (var i = 0; i < carryRuleList.length; i++) {
        if (carryRuleList[i].id == param.carryRuleId) {
            carryRule = carryRuleList[i];
        }
    }
    if (!carryRule || JSON.stringify(carryRule) == "{}") {
        zmCarryRule.weig = zmFlipRule.param.weig;
    } else {
        carryRule.weig = zmCarryRule.param.weig;
        let weig = zmCarryRule.getResult(carryRule);
        zmCarryRule.weig = parseFloat(weig).toFixed(3);
    }
    return zmCarryRule.weig ? parseFloat(zmCarryRule.weig) : 0;
};


const getWeig = function (carryRuleList) {
    if (carryRuleList == null || carryRuleList.length < 1) {
        return zmCarryRule.param.weig;
    }
    let carryRule = {};
    for (var i = 0; i < carryRuleList.length; i++) {
        if (carryRuleList[i].id == zmCarryRule.param.carryRuleId) {
            carryRule = carryRuleList[i];
        }
    }
    if (!carryRule || JSON.stringify(carryRule) == "{}") {
        zmCarryRule.weig = zmCarryRule.param.weig;
    } else {
        carryRule.weig = zmCarryRule.param.weig;
        let weig = zmCarryRule.getResult(carryRule);
        zmCarryRule.weig = parseFloat(weig).toFixed(6);
    }
    return zmCarryRule.weig ? parseFloat(zmCarryRule.weig) : 0;
}

zmCarryRule.callAsync = function (param) {
    return new Promise((resolve,reject) => {
        zmCarryRule.param = param;
        let carryRuleList = util.get("carryRuleList");
        if (!carryRuleList || carryRuleList.length <= 0) {
            httpservice.get('/bas/carry/rule/list').then(res => {
                if (res) {
                    util.set("carryRuleList", res);
                    let weig = getWeig(res);
                    resolve(weig);
                }
            }).catch(res => {
            });
        }else{
            let weig2 = getWeig(carryRuleList);
            resolve(weig2);
        }
    })
};

export default zmCarryRule;


// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/utils/zmCarryRuleService.js